var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 333.786,
    height: 259.274,
    viewBox: "0 0 333.786 259.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151047",
    "data-name": "Rectangle 151047",
    width: 333.787,
    height: 259.274,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_170442",
    "data-name": "Group 170442",
    transform: "translate(0 -0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170440",
    "data-name": "Group 170440",
    transform: "translate(0 0.005)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41825",
    "data-name": "Path 41825",
    d: "M1149.425,1100.084s32.74-16.143,38.37-24.563-2.646-8.9-2.646-8.9,14.61-14.209,12.554-20.192-9.624-.5-9.624-.5,9.394-20.912,4.965-23.014c-8.251-3.916-19.825,18.585-19.825,18.585s2.487-9.775-3.194-9.457c-8.568.479-8.214,22.589-8.214,22.589s-.968-8.478-6.132-5.724c-9.266,4.941-6.254,51.167-6.254,51.167",
    transform: "translate(-946.841 -842.603)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41826",
    "data-name": "Path 41826",
    d: "M1151.547,1045.5c4.032-2.238,8.049,4.3,8.049,4.3s-.407-17.269,8.161-17.749c5.681-.318,3.194,9.457,3.194,9.457s11.574-22.5,19.825-18.585l-43.657,76.8c-.308-5.363-3.561-49.794,4.428-54.227",
    transform: "translate(-944.573 -842.603)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41827",
    "data-name": "Path 41827",
    d: "M1156.424,1303.471s26.777,3.326,33.71.362,1.964-6.624,1.964-6.624,14.887-2.926,16.035-7.492-5.719-4.2-5.719-4.2,14.275-9.244,12.366-12.355c-3.555-5.795-19.917,3.536-19.917,3.536s5.523-5.086,1.85-7.2c-5.539-3.183-14.3,10.752-14.3,10.752s.544-3.435-3.8-3.815c-7.787-.683-22.192,27.036-22.192,27.036",
    transform: "translate(-952.994 -1045.789)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41828",
    "data-name": "Path 41828",
    d: "M1178.059,1262.144c4.34.381,3.971,6.311,3.971,6.311s8.922-16.518,14.461-13.335c3.673,2.11-.673,9.042-.673,9.042s15.026-8.593,18.581-2.8l-58.438,30.163c1.987-3.47,14.823-30.021,22.1-29.383",
    transform: "translate(-952.613 -1033.994)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41829",
    "data-name": "Path 41829",
    d: "M531.446,1095.287s-32.74-16.143-38.37-24.562,2.646-8.9,2.646-8.9-14.61-14.21-12.555-20.191,9.726-.266,9.726-.266-9.5-21.142-5.067-23.244c8.25-3.915,19.824,18.585,19.824,18.585s-2.487-9.775,3.194-9.457c8.568.479,8.214,22.589,8.214,22.589s.968-8.478,6.132-5.724c9.266,4.941,6.255,51.167,6.255,51.167",
    transform: "translate(-398.009 -838.649)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41830",
    "data-name": "Path 41830",
    d: "M549.811,1040.7c-4.033-2.238-8.049,4.3-8.049,4.3s.407-17.27-8.161-17.748c-5.681-.318-3.194,9.457-3.194,9.457s-11.574-22.5-19.825-18.585l43.657,76.8c.309-5.363,3.561-49.795-4.428-54.227",
    transform: "translate(-420.764 -838.649)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41831",
    "data-name": "Path 41831",
    d: "M479.542,1298.674s-26.777,3.325-33.71.362-1.964-6.625-1.964-6.625-14.887-2.926-16.036-7.492,5.958-4.118,5.958-4.118-14.514-9.328-12.605-12.439c3.555-5.8,19.917,3.536,19.917,3.536s-5.523-5.086-1.85-7.2c5.539-3.183,14.3,10.752,14.3,10.752s-.544-3.435,3.8-3.815c7.787-.683,22.192,27.036,22.192,27.036",
    transform: "translate(-346.951 -1041.835)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41832",
    "data-name": "Path 41832",
    d: "M457.7,1254.692a4.537,4.537,0,0,0-4.272,4.6s-7.989-12.647-13.528-9.464c-3.673,2.11.673,9.042.673,9.042s-15.026-8.593-18.581-2.8l58.438,30.164c-1.987-3.47-15.456-32.177-22.73-31.539",
    transform: "translate(-347.761 -1029.542)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41833",
    "data-name": "Path 41833",
    d: "M1634.472,988.08c.805-1.938,1.625-3.881,3.715-4.863a4.676,4.676,0,0,1,4.961.635c4.258,3.2.548,6.73,5.4,12.8,1.506,1.887,3.329,3.41,4.232,5.621,1.263,3.095-.241,4.581-2.653,6.063-11.538,7.092-17.586-7.469-17.369-10.8a53.6,53.6,0,0,1,1.718-9.459",
    transform: "translate(-1345.527 -809.889)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41834",
    "data-name": "Path 41834",
    d: "M1587.41,1380.015A32.63,32.63,0,0,0,1589,1385.1c.058.127.588.58.652.71-.167,3.168-2.115,5.114-3.958,6.516.355-1.607,1.2-3.466,1.075-3.816a45.194,45.194,0,0,0-2.694-6.289c1.567-.232,2.093-1.207,3.341-2.21",
    transform: "translate(-1305.411 -1137.253)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41835",
    "data-name": "Path 41835",
    d: "M1558.823,1166.126l9.822,7.46s-4.863,4.679-6.688,6.418-13.08,9.837-13.239,10.235c-.118.3,2.561,9.605,4.288,14.575a12,12,0,0,1-4.678,2.444c-3.405-6.5-7.59-17.588-7.59-19.094,0-2.452,18.084-22.039,18.084-22.039",
    transform: "translate(-1269.703 -960.99)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41836",
    "data-name": "Path 41836",
    d: "M1769.731,1232.738a44.823,44.823,0,0,0-3.265,6.69c-1.188-.748-1.906-1.639-3.233-2.142a33.279,33.279,0,0,0,3.256-6.028c.4-2.058.865-2.362.865-2.362s6.9,2.335,7.36,2.989-3.694-.4-4.984.853",
    transform: "translate(-1453.058 -1012.718)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41837",
    "data-name": "Path 41837",
    d: "M1780.242,1227.051c-.535,0,.046-2.418.169-2.976a1.043,1.043,0,0,1,.592-.837c.245-.06,7.914,2.534,9.21,3.466a1.547,1.547,0,0,1,.269.308c.71,1.324-5.613,1.576-6.522,1-.809-.515-1.309-.964-3.717-.958",
    transform: "translate(-1466.891 -1008.055)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41838",
    "data-name": "Path 41838",
    d: "M1631.612,1162.42l8.574-3.464c-.034.015.052.349.058.375.8,3.131,5.1,1.923,6.866,7.36,1.251,3.842,3.083,18.211,3.083,18.211a41.363,41.363,0,0,1,5.332-7.015c.313-.352,4.287,2.377,4.287,2.377-2.955,7.835-10.213,14.2-11.2,13.751-6.639-3.046-14.613-27.078-14.6-27.076-.755-1.47-2.4-4.519-2.4-4.519",
    transform: "translate(-1344.59 -955.081)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41839",
    "data-name": "Path 41839",
    d: "M1586.5,915.076s-4.021-6.367-4.721-8.484-.005-12.2.061-12.921,2.5-2.677,2.114-3.24-3.738-1.023-4.3-.913-1.658.009-2.105.463c-.058.059,1.068,2.715,1.044,3.126-.16,2.811-1.756,11.759-1.234,14.179.6,2.782,6.572,11.674,6.572,11.674Z",
    transform: "translate(-1299.792 -733.028)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41840",
    "data-name": "Path 41840",
    d: "M1712.823,1039.638s10.757.268,13.119.462,10.931-.519,11.263-.558,2.527-3.756,2.892-3.357-1.222,1.844-.731,2.218,5.761-.464,5.691-.075c-.131.729-3.206.636-3.2.988s3.219-.2,3.437.387-3.093.238-3.225.5,3.071.738,2.743,1.282c-.178.3-2.838-.493-2.825-.09s1.954,1.318,1.716,1.638-1.523-.983-2.649-1-1.932-.6-3.729-.111-7.924,2.964-11.759,2.782-12.31-.56-12.31-.56Z",
    transform: "translate(-1411.515 -853.883)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41841",
    "data-name": "Path 41841",
    d: "M1607.988,1047.286c-.146-1.774-.394-6.562-.314-7.15-.537-1.843-2.495-4.575-2.905-5.348,0,0,2.656-3.009,4.626-2.984a16.525,16.525,0,0,0,3.651,3.457,3.855,3.855,0,0,0,.782.234c1.5-.011,6.748-.17,7.728.122l-.555,8.108c-.282.465-.624,9.787-1.205,10.554s-9.026,4.26-10.425,3.359c-.056-.036-1.085-6.766-1.381-10.353",
    transform: "translate(-1322.469 -850.298)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41842",
    "data-name": "Path 41842",
    d: "M1684.656,1052.454c.968-.462,8.038-.447,8.038-.447s.979,4.877.188,6.049c0,0-6.262.932-6.084,1.445Z",
    transform: "translate(-1388.303 -866.946)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41843",
    "data-name": "Path 41843",
    d: "M1655.3,1028.94a21.6,21.6,0,0,0-.435,3.922c.109,1.109-.415,4.685-2.763,4.7s-.446-4.546-.225-5.633a41.607,41.607,0,0,0,.274-4.453Z",
    transform: "translate(-1360.517 -846.728)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41844",
    "data-name": "Path 41844",
    d: "M1657.542,1029.161c.036-.921.048-1.689.048-1.689l3.149,1.467s-.111.575-.223,1.308a2.75,2.75,0,0,1-2.974-1.086",
    transform: "translate(-1365.959 -846.727)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41845",
    "data-name": "Path 41845",
    d: "M1656.3,989.944a3.9,3.9,0,0,1,1.657,2.132c.444,1.459-.061,5.224-3.2,6.133s-4.493-2.073-3.847-4.4,2.05-5.283,5.386-3.861",
    transform: "translate(-1360.365 -815.495)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41846",
    "data-name": "Path 41846",
    d: "M1649.373,1002.876c.062.626.407,1.1.772,1.069s.611-.572.549-1.2-.407-1.1-.771-1.069-.611.572-.549,1.2",
    transform: "translate(-1359.219 -825.469)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41847",
    "data-name": "Path 41847",
    d: "M1594.165,1408.9c.181-.5,2.233,1.011,2.716,1.316a1.043,1.043,0,0,1,.586.841c-.026.244-4.893,6.681-6.35,7.6a.851.851,0,0,1-.521.068c-.837-.289.331-5.459,1.38-6.508a6.58,6.58,0,0,0,2.19-3.315",
    transform: "translate(-1310.554 -1160.972)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41848",
    "data-name": "Path 41848",
    d: "M1564.625,772.33l-8.636,3.07a1.419,1.419,0,0,0-.9.972l-2.363,8.878a1.417,1.417,0,0,1-2.5.5l-5.592-7.292a1.42,1.42,0,0,0-1.2-.554l-9.154.477a1.424,1.424,0,0,1-1.246-2.227l5.18-7.577a1.426,1.426,0,0,0,.154-1.315l-3.294-8.584a1.419,1.419,0,0,1,1.725-1.874l8.793,2.61a1.416,1.416,0,0,0,1.3-.258l7.118-5.782a1.42,1.42,0,0,1,2.312,1.069l.255,9.19a1.426,1.426,0,0,0,.647,1.155l7.693,5.01a1.424,1.424,0,0,1-.3,2.534",
    transform: "translate(-1263.155 -620.582)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41849",
    "data-name": "Path 41849",
    d: "M1600.941,894.8c.322.473-1.423,1.971-1.907,2.8l-1.1-1.493c.54-.105,2.635-1.847,3-1.307",
    transform: "translate(-1316.84 -737.312)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41850",
    "data-name": "Path 41850",
    d: "M1680.172,990.6s.568,4.2,1.926,4.958.789,2.621.789,2.621,1.232-4.327.158-5.716a5.977,5.977,0,0,0-2.874-1.863",
    transform: "translate(-1384.608 -816.345)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41851",
    "data-name": "Path 41851",
    d: "M1685.262,1019.226c-.368.547-.367,1.193,0,1.442s.968.007,1.336-.54.367-1.193,0-1.441-.968-.007-1.337.54",
    transform: "translate(-1388.576 -839.406)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41852",
    "data-name": "Path 41852",
    d: "M1595.477,897.293c.008.01.018.019.026.029l.4.518a1.584,1.584,0,0,0-1.391.134,1.69,1.69,0,0,1,.969-.681",
    transform: "translate(-1314.014 -739.448)",
    fill: "#f47257"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41853",
    "data-name": "Path 41853",
    d: "M185.859,1162.582a17.239,17.239,0,0,1-2.864,3.354,12.519,12.519,0,0,0-2.672,5.152c-.58,2.91-.1,17.289-.6,18.312-4.337,4.24-7.477,14.88-8.359,18.126a3.475,3.475,0,0,1-1,1.647l.193,3.668,2.155,1.985a10.993,10.993,0,0,1,.478-5.206s10.919-16.536,11.567-17.8c1.238-3.6,5.748-22.042,5.748-22.042l1.047-4.239s-5.679-2.955-5.688-2.958",
    transform: "translate(-140.391 -958.07)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41854",
    "data-name": "Path 41854",
    d: "M156.941,1428.341a13.042,13.042,0,0,1,1.48,2.921c.117.819.843,2.677,1.646,2.794.182.027,3.307.256,3.284-.134-.017-.3-1.148-.725-1.674-1.088-.908-.627-2.317-5.733-2.317-5.733s-2.362.586-2.421,1.24",
    transform: "translate(-129.333 -1176.056)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41855",
    "data-name": "Path 41855",
    d: "M280.529,1183.868s7.033,15.037,7.078,17.681c.039,2.266-1.229,14.981-.875,25.57.013.382.5.891,1.2,1.213.4.182,2.312,1.037,2.312,1.037l.263.685-6.6-.47-.094-1.8s-2.625-15.84-2.357-20.32c.042-.7.384-4.917.384-4.917l-7.931-15.314,4.989-6.555Z",
    transform: "translate(-225.728 -972.983)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41856",
    "data-name": "Path 41856",
    d: "M226.339,973.9a6.088,6.088,0,0,0-6.749-4.027,6.362,6.362,0,0,0-3.986-2.847c-3.183-.682-7.488.575-7.372,3.946-1.235,2.264-1.282,5.5.607,7.223-.657,3.045,2.194,5.989,5.9,5.881a6.554,6.554,0,0,0,6.2,3.206,14.864,14.864,0,0,1,1.631-.18c-.186-.034,3.928,3.12,7.415-1.731,3.558-4.95,1.058-10.943-3.643-11.471",
    transform: "translate(-170.878 -796.77)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41857",
    "data-name": "Path 41857",
    d: "M278.658,895.013a6.581,6.581,0,0,1,.633-1.16l.275-.4a1.812,1.812,0,0,0,.074-.171,6.4,6.4,0,0,0,.028-1.5l-2.406.582-.528,1.388c-.535-.248-1.45-2.109-1.784-1.662-.395.528,1.092,2.817,1.209,3.437s-1.278,10.241-1.681,12.152-3.125,7.245-3.125,7.245l2.49,3.16s3.992-8.132,4.254-10.615c.028-.261.059-.652.092-1.136Z",
    transform: "translate(-223.619 -734.909)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41858",
    "data-name": "Path 41858",
    d: "M120.43,1067.677l-2.957-2.507s-2.394,3.991-4.312,7.246a60.538,60.538,0,0,1-7.06-4.04c-.243-.147-.782-3.769-1.2-3.577s.32,1.911-.185,2.04-4.29-2.4-4.368-2.063c-.145.632,2.259,1.64,2.138,1.921s-2.417-1.291-2.783-.9,2.307,1.28,2.32,1.536-2.62-.487-2.55.065c.038.3,2.357.6,2.211.921s-1.953.371-1.878.713,1.508-.255,2.383.128,1.7.195,2.916,1.224,7.216,6.9,9.085,6.4c1.632-.44,6.238-9.105,6.238-9.105",
    transform: "translate(-81.975 -877.445)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41859",
    "data-name": "Path 41859",
    d: "M219.881,1301.489s0,0,0,0h0",
    transform: "translate(-181.201 -1072.54)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41860",
    "data-name": "Path 41860",
    d: "M203,1026.448c.189-1.156,1.978-4.049,2.261-4.759,0,0-2.074-2.636-3.758-2.436,0,0-2.263,3.751-3.549,3.877s-5.812.322-6.6.8-4.159,5.649-4.159,5.649,3.024,3.089,4.241,3.082a12.765,12.765,0,0,1,.9-1.552c.183.591,3,9.722,3,11.79l.022.017a5.918,5.918,0,0,0,8.51-1.093,47.01,47.01,0,0,1-.1-5.471c.212-4.112,1.044-6.3-.76-9.908",
    transform: "translate(-154.261 -839.945)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41861",
    "data-name": "Path 41861",
    d: "M241.046,1167.574l-13.8-19.942a13.537,13.537,0,0,1-2.566.82,26.6,26.6,0,0,1-5.965.255,1.464,1.464,0,0,1-.012.2c-.23,1.644-2.411,4.19-2.861,9.179a122.045,122.045,0,0,0-.029,16.146c9.177-1.116,22.632-3.921,25.236-6.654",
    transform: "translate(-177.639 -945.75)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41862",
    "data-name": "Path 41862",
    d: "M302.135,901.3a2.386,2.386,0,0,1-1.6.394,3.013,3.013,0,0,1-1.075-.461,3.023,3.023,0,0,0,1.008,1.066c1.037.557,1.671-1,1.671-1",
    transform: "translate(-246.778 -742.699)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41863",
    "data-name": "Path 41863",
    d: "M208.153,756.162l8.026-1.656a1.234,1.234,0,0,1,1.131.351l5.869,5.967a1.254,1.254,0,0,0,2.141-.789l.958-8.484a1.321,1.321,0,0,1,.667-1.014l7.239-3.973a1.349,1.349,0,0,0-.061-2.371l-7.434-3.588a1.319,1.319,0,0,1-.718-.977l-1.395-8.422a1.253,1.253,0,0,0-2.179-.676l-5.553,6.267a1.234,1.234,0,0,1-1.111.41l-8.1-1.232a1.312,1.312,0,0,0-1.285,1.953l4,7.46a1.374,1.374,0,0,1,.032,1.23l-3.611,7.661a1.311,1.311,0,0,0,1.384,1.883",
    transform: "translate(-169.912 -601.671)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41864",
    "data-name": "Path 41864",
    d: "M235.145,1016.058a20.862,20.862,0,0,1,.388,3.646c-.1,1.031.37,4.355,2.467,4.366s.4-4.226.2-5.237a40.23,40.23,0,0,1-.244-4.139Z",
    transform: "translate(-193.78 -836.197)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41865",
    "data-name": "Path 41865",
    d: "M238,1016.264c-.033-.856-.043-1.57-.043-1.57l-2.811,1.364s.1.535.2,1.216a2.409,2.409,0,0,0,2.656-1.01",
    transform: "translate(-193.78 -836.197)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41866",
    "data-name": "Path 41866",
    d: "M221.793,979.809a3.591,3.591,0,0,0-1.479,1.982c-.4,1.356.055,4.856,2.853,5.7s4.011-1.927,3.434-4.094-1.83-4.911-4.808-3.589",
    transform: "translate(-181.456 -807.164)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41867",
    "data-name": "Path 41867",
    d: "M253.064,991.831c-.055.582-.363,1.027-.689.993s-.545-.532-.49-1.114.363-1.027.689-.994.545.532.49,1.114",
    transform: "translate(-207.568 -816.436)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41868",
    "data-name": "Path 41868",
    d: "M218.722,1007.029c.329.509.328,1.109,0,1.34s-.864.006-1.193-.5-.328-1.109,0-1.34.864-.007,1.193.5",
    transform: "translate(-179.058 -829.391)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41869",
    "data-name": "Path 41869",
    d: "M303.542,883.446c-.543-.105-2.84,1.7-2.819,1.967s2.262-.873,2.326-.69c.05.144-2.509.815-2.375,1.072.091.175,2.387-.308,2.448-.2.1.176-1.915.251-1.785.445.15.225,2.065.133,2.065.133a4.339,4.339,0,0,0,.425-.852,1.884,1.884,0,0,0,.009-.4c-.008-.128.049-.238.031-.381-.072-.58-.024-1.043-.324-1.1",
    transform: "translate(-247.777 -728.034)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41870",
    "data-name": "Path 41870",
    d: "M292.878,890.728l-.855,1.057-.564-.421a.28.28,0,0,1,.019-.235c.066-.147,1.381-.793,1.4-.4",
    transform: "translate(-240.174 -733.936)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41871",
    "data-name": "Path 41871",
    d: "M329.834,1451.633h8.332c.308-.027.383-.276.276-.429a10.126,10.126,0,0,0-2.285-1.05c-1.917.2-6.09-1.11-6.392-1.55a8.11,8.11,0,0,0,.068,3.029",
    transform: "translate(-271.673 -1193.777)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41872",
    "data-name": "Path 41872",
    d: "M294.684,896.9a5.46,5.46,0,0,1,1.6,1.5,1.945,1.945,0,0,1,.252,1.477l-1.938-2.384Z",
    transform: "translate(-242.774 -739.123)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41873",
    "data-name": "Path 41873",
    d: "M1146.942,361.05a8.453,8.453,0,0,1-.876,2.715q-1.269,1.533-2.4,3.159c.522-.038,1.047-.062,1.577-.062a19.972,19.972,0,0,1,13.673,5.174,14.108,14.108,0,0,1,0,21.527,20.653,20.653,0,0,1-27.317.026c-.262.775-.523,1.545-.783,2.319a6.021,6.021,0,0,0-3,5.442c0,3.258,2.187,5.9,4.884,5.9a5.039,5.039,0,0,0,4.6-3.919,25.091,25.091,0,0,0,7.943,1.283c12.992,0,23.525-9.766,23.525-21.813,0-11.515-9.626-20.94-21.823-21.75",
    transform: "translate(-929.419 -297.538)",
    fill: "#e0973f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41874",
    "data-name": "Path 41874",
    d: "M534.582,361.05a8.453,8.453,0,0,0,.876,2.715q1.269,1.533,2.4,3.159c-.522-.038-1.047-.062-1.577-.062a19.971,19.971,0,0,0-13.673,5.174,14.107,14.107,0,0,0,0,21.527,20.652,20.652,0,0,0,27.316.026c.262.775.523,1.545.783,2.319a6.021,6.021,0,0,1,3,5.442c0,3.258-2.187,5.9-4.884,5.9a5.039,5.039,0,0,1-4.6-3.919,25.089,25.089,0,0,1-7.943,1.283c-12.992,0-23.525-9.766-23.525-21.813,0-11.515,9.626-20.94,21.823-21.75",
    transform: "translate(-422.558 -297.538)",
    fill: "#e0973f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41875",
    "data-name": "Path 41875",
    d: "M731.957,346.931v6.022a49.288,49.288,0,0,1-49.284,49.284c-12.536-.166-21.136,1.129-33.038-4.14a49.3,49.3,0,0,1-29.494-45.144v-6.022Z",
    transform: "translate(-511.049 -285.902)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41876",
    "data-name": "Path 41876",
    d: "M718.057,398.1l.038.017,17.716-51.183H717.368l-14.2,41.032A49.35,49.35,0,0,0,718.057,398.1",
    transform: "translate(-579.472 -285.902)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41877",
    "data-name": "Path 41877",
    d: "M813.508,401.551l18.694-54.62h-9.264l-17.929,52.394a44.7,44.7,0,0,0,8.5,2.226",
    transform: "translate(-663.397 -285.902)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41878",
    "data-name": "Path 41878",
    d: "M678.56,386.088l13.98-39.157h-4.4L675.487,382.36q1.447,1.941,3.073,3.728",
    transform: "translate(-556.66 -285.902)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41879",
    "data-name": "Path 41879",
    d: "M718.676,327.526H616.9c-3.714,0-6.742,2.067-6.956,4.672H725.631c-.214-2.6-3.241-4.672-6.956-4.672",
    transform: "translate(-502.65 -269.911)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41880",
    "data-name": "Path 41880",
    d: "M830.542,653.13l5.758,29.56h25.18l7.134-29.56Z",
    transform: "translate(-684.439 -538.237)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41881",
    "data-name": "Path 41881",
    d: "M868.619,653.142l-1.61,6.67H831.848l-1.3-6.67Z",
    transform: "translate(-684.443 -538.247)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41882",
    "data-name": "Path 41882",
    d: "M868.619,890.568H830.547L833.4,875.9l2.9-14.888h25.184l3.595,14.888Z",
    transform: "translate(-684.443 -709.546)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41883",
    "data-name": "Path 41883",
    d: "M868.619,960.315H830.547l2.854-14.672h31.68Z",
    transform: "translate(-684.443 -779.293)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41884",
    "data-name": "Path 41884",
    d: "M859.451,821.17H825.436a2.717,2.717,0,0,0-2.717,2.717v1.574a2.717,2.717,0,0,0,2.717,2.717h34.015a2.717,2.717,0,0,0,2.717-2.717v-1.574a2.717,2.717,0,0,0-2.717-2.717",
    transform: "translate(-677.992 -676.716)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41885",
    "data-name": "Path 41885",
    d: "M852.259,972.458h-44.97v-8.077a1.575,1.575,0,0,1,1.576-1.575h41.819a1.575,1.575,0,0,1,1.575,1.575Z",
    transform: "translate(-665.276 -793.437)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41886",
    "data-name": "Path 41886",
    d: "M797.5,1021.762v2.937H722.8v-2.937c0-3.384,2.065-6.13,4.61-6.13h65.474c2.545,0,4.61,2.747,4.61,6.13",
    transform: "translate(-595.654 -836.97)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41887",
    "data-name": "Path 41887",
    d: "M797.1,1015.632l-2.363,9.067h-3.117l2.363-9.067Z",
    transform: "translate(-652.363 -836.97)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41888",
    "data-name": "Path 41888",
    d: "M771.71,1015.632l-2.363,9.067h-3.121l2.367-9.067Z",
    transform: "translate(-631.437 -836.97)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41889",
    "data-name": "Path 41889",
    d: "M819.639,1015.632l-2.363,9.067h-3.121l2.367-9.067Z",
    transform: "translate(-670.934 -836.97)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41890",
    "data-name": "Path 41890",
    d: "M719.158,1419.806v2.937H593.995v-2.937c0-3.384,3.461-6.13,7.725-6.13H711.433c4.264,0,7.725,2.746,7.725,6.13",
    transform: "translate(-489.504 -1164.993)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41891",
    "data-name": "Path 41891",
    d: "M718.49,1413.676l-3.96,9.067h-5.224l3.96-9.067Z",
    transform: "translate(-584.53 -1164.993)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41892",
    "data-name": "Path 41892",
    d: "M675.945,1413.676l-3.96,9.067h-5.23l3.966-9.067Z",
    transform: "translate(-549.465 -1164.993)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41893",
    "data-name": "Path 41893",
    d: "M756.259,1413.676l-3.96,9.067h-5.23l3.966-9.067Z",
    transform: "translate(-615.65 -1164.993)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41894",
    "data-name": "Path 41894",
    d: "M820.074,621.382V623.6a6.941,6.941,0,0,1-6.939,6.945H763a6.943,6.943,0,0,1-6.945-6.945v-2.216Z",
    transform: "translate(-623.051 -512.074)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41895",
    "data-name": "Path 41895",
    d: "M765.54,1128.135H671.351l1.149-60.952h91.777Z",
    transform: "translate(-553.252 -879.453)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41896",
    "data-name": "Path 41896",
    d: "M848.072,1128.135H798.68l.6-60.952h48.127Z",
    transform: "translate(-658.182 -879.453)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41897",
    "data-name": "Path 41897",
    d: "M314.052,1465.218H.709a.709.709,0,1,0,0,1.418H314.052a.709.709,0,1,0,0-1.418",
    transform: "translate(0 -1207.468)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41898",
    "data-name": "Path 41898",
    d: "M938.782,1066.909l-7.469-12.2-10.977,9.166,11.294-68.769,18.445,3.029Z",
    transform: "translate(-758.438 -820.059)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41899",
    "data-name": "Path 41899",
    d: "M1079.118,1063.807l-11-9.14-7.44,12.212-11.453-68.743,18.438-3.072Z",
    transform: "translate(-864.655 -820.021)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41900",
    "data-name": "Path 41900",
    d: "M946.665,912.842c0,3.973-3.5,7.344-4.667,10.929-1.207,3.715-.4,8.493-2.646,11.585-2.273,3.124-7.083,3.818-10.206,6.091-3.093,2.251-5.227,6.623-8.942,7.83-3.585,1.164-7.865-1.081-11.838-1.081s-8.253,2.245-11.838,1.081c-3.715-1.206-5.85-5.579-8.942-7.83-3.123-2.273-7.933-2.967-10.207-6.091-2.25-3.092-1.439-7.87-2.645-11.586-1.164-3.585-4.667-6.955-4.667-10.928s3.5-7.344,4.667-10.928c1.206-3.715.4-8.493,2.646-11.586,2.273-3.123,7.083-3.818,10.207-6.091,3.092-2.251,5.227-6.624,8.942-7.83,3.585-1.164,7.865,1.081,11.838,1.081s8.254-2.245,11.838-1.081c3.715,1.206,5.85,5.579,8.942,7.83,3.123,2.273,7.933,2.968,10.207,6.091,2.251,3.092,1.439,7.87,2.645,11.585,1.164,3.585,4.667,6.956,4.667,10.928",
    transform: "translate(-717.01 -721.961)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41901",
    "data-name": "Path 41901",
    d: "M930.929,959.855a20.408,20.408,0,0,1-4.088-.634,19.416,19.416,0,0,0-10.912,0,20.409,20.409,0,0,1-4.089.633,4.614,4.614,0,0,1-1.435-.2c-1.531-.5-2.905-2.057-4.359-3.709a24.194,24.194,0,0,0-3.805-3.725,24.534,24.534,0,0,0-4.764-2.506c-2.007-.873-3.9-1.7-4.83-2.973-.913-1.255-1.114-3.3-1.327-5.47a24.978,24.978,0,0,0-.922-5.338,23.759,23.759,0,0,0-2.334-4.7c-1.13-1.906-2.2-3.706-2.2-5.368s1.067-3.462,2.2-5.368a23.752,23.752,0,0,0,2.334-4.7,24.944,24.944,0,0,0,.923-5.339c.213-2.168.414-4.216,1.327-5.47.929-1.276,2.824-2.1,4.83-2.973a24.541,24.541,0,0,0,4.765-2.506,24.213,24.213,0,0,0,3.806-3.725c1.454-1.652,2.828-3.212,4.36-3.709a4.623,4.623,0,0,1,1.435-.2,20.411,20.411,0,0,1,4.089.633,19.418,19.418,0,0,0,10.912,0,20.4,20.4,0,0,1,4.088-.633,4.623,4.623,0,0,1,1.435.2c1.531.5,2.905,2.058,4.36,3.709a24.237,24.237,0,0,0,3.8,3.724,24.555,24.555,0,0,0,4.765,2.506c2.007.873,3.9,1.7,4.83,2.973.913,1.255,1.114,3.3,1.327,5.47a25,25,0,0,0,.922,5.338,23.766,23.766,0,0,0,2.335,4.7c1.13,1.906,2.2,3.706,2.2,5.368s-1.067,3.462-2.2,5.368a23.7,23.7,0,0,0-2.334,4.7,24.964,24.964,0,0,0-.923,5.338c-.213,2.168-.413,4.216-1.327,5.47-.929,1.276-2.824,2.1-4.83,2.973a24.543,24.543,0,0,0-4.765,2.506,24.218,24.218,0,0,0-3.8,3.725c-1.454,1.652-2.828,3.212-4.36,3.709a4.611,4.611,0,0,1-1.436.2",
    transform: "translate(-730.03 -734.983)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41902",
    "data-name": "Path 41902",
    d: "M984.988,954.4a27.9,27.9,0,1,1-27.9-27.9,27.9,27.9,0,0,1,27.9,27.9",
    transform: "translate(-765.734 -763.516)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41903",
    "data-name": "Path 41903",
    d: "M963.6,987.416a26.509,26.509,0,1,1,26.509-26.509A26.539,26.539,0,0,1,963.6,987.416",
    transform: "translate(-772.244 -770.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41904",
    "data-name": "Path 41904",
    d: "M999.231,972.506A24.033,24.033,0,1,1,975.2,948.473a24.033,24.033,0,0,1,24.033,24.033",
    transform: "translate(-783.843 -781.625)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41905",
    "data-name": "Path 41905",
    d: "M1005,1038l.894-6.744h-2.821v-2.03h3.131l.654-4.989H1003.9v-2.03h3.269l.895-6.572h2l-.86,6.572h3.578l.894-6.572h2.03l-.86,6.572h2.821v2.03h-3.131l-.619,4.989h2.959v2.03H1013.6l-.9,6.744h-2.064l.894-6.744h-3.578l-.894,6.744Zm6.847-8.774.654-4.989h-3.578l-.654,4.989Z",
    transform: "translate(-826.619 -836.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41906",
    "data-name": "Path 41906",
    d: "M1117.933,1018.453h-.069l-3.888,2.1-.585-2.306,4.886-2.615h2.581V1038h-2.924Z",
    transform: "translate(-917.531 -836.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41907",
    "data-name": "Path 41907",
    d: "M1219.156,90.471c-.263,1.079-.736,2.783-.736,2.783.037.469.176,2.419.341,4.809l-3.513-1.406a37.99,37.99,0,0,0-.115-4.133c-.133-.2-.355.05-1.432-1.491a3.01,3.01,0,0,1-.369-1.24s-.064-.978.155-1.069a.457.457,0,0,1,.552.224c.079.169.059.563.138.732a1.216,1.216,0,0,0,.8.362c.214-.011-.027-2.894-.027-2.894s-.119-.818-.18-1.085c-.052-.228-.26-.9-.26-.9s-.243-.97.058-1.044c.178-.044.63.745.94,1.581a16.981,16.981,0,0,0,.619,1.844c.224-.03.105-1.611.105-1.611a5.078,5.078,0,0,1-.218-1.066c-.211-.419-.351-1.2.021-1.26a6.445,6.445,0,0,1,.558.975s.193.695.3,1.019c.2.573.228,1.477.331,1.876.086.332.164.2.2.209a8.284,8.284,0,0,0-.075-1.076,6.361,6.361,0,0,0-.08-1.043,7.639,7.639,0,0,1-.15-1.1c-.06-.818.455-.734.633.014.068.285.139.6.21.911.277,1.226.269,2.406.4,2.416a8.893,8.893,0,0,0,.058-2.137s.263-1.19.525-.086a9.621,9.621,0,0,1,.268,2.373,9.308,9.308,0,0,1-.064,2.51",
    transform: "translate(-999.883 -68.903)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41908",
    "data-name": "Path 41908",
    d: "M1167.049,146.131s-3.959-.947-4-.63c-.832,6.964-1.205,9.483-1.346,9.555-.48.247-6.839-5.569-7.974-5.963a4.734,4.734,0,0,0-1.7-.14c-1.349.04-1.615.045-1.615.045l-.049,0,.007,1.269c1.519,1.367,5,22.078,5.291,22.065.328-.015,7.2,1.715,7.083,1.136-.02-.094-4.662-3.893-5.979-9.375-.442-1.84-.661-3.822-.9-5.557,1.528.766,7.5,3.7,8.441,3.315,2.942-1.207,2.735-15.722,2.735-15.722",
    transform: "translate(-948.005 -119.853)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41909",
    "data-name": "Path 41909",
    d: "M1312.5,347.949s6.4,5.012,6.611,5.9c.308,1.28,6.166-.4,4.754-.663-.325-.06-1.365-.324-1.451-.37-.457-.244-6.15-7.1-6.15-7.1Z",
    transform: "translate(-1081.615 -284.898)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41910",
    "data-name": "Path 41910",
    d: "M1356.507,386.641l-4.085-.333a5.788,5.788,0,0,1-3.411,1.011,5.229,5.229,0,0,0-.188,2.223c.029.207.064.831.272.817.755-.051,2.766-.552,5.056-1.01a19.751,19.751,0,0,0,4.858-1.716c1.778-1.064-2.5-.994-2.5-.994",
    transform: "translate(-1111.509 -318.352)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41911",
    "data-name": "Path 41911",
    d: "M1141.962,275.607a27.962,27.962,0,0,0,9.867-.425c6-1.4,12.626-2.7,14.568-1.57,1.564.909,11.328,15.663,11.328,15.663l-3.771,2.752L1163.2,279.988s-13.716,5.061-16.8,4.5c-7.016-1.277-7.116-6.88-4.444-8.881",
    transform: "translate(-939.743 -225.127)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41912",
    "data-name": "Path 41912",
    d: "M1154.664,270.043l4.688,5.571-8.7,2.65-1.114-5.243Z",
    transform: "translate(-947.323 -222.54)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41913",
    "data-name": "Path 41913",
    d: "M1230.622,414.7s-.285,7.738-.462,9.048,3.284,5.234,2.842,3.867c-.1-.314-.364-1.355-.364-1.452,0-.519,1.283-9.346,1.283-9.346Z",
    transform: "translate(-1013.754 -341.748)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41914",
    "data-name": "Path 41914",
    d: "M1219.813,472.874l-2.555-4.154a5.791,5.791,0,0,1-2.511-2.521,5.225,5.225,0,0,0-2.045.891c-.168.124-1.313.961-1.233,1.154a21.97,21.97,0,0,0,3.555,3.9,45.873,45.873,0,0,0,4.2,3.007c1.781,1.059.593-2.272.593-2.272",
    transform: "translate(-998.352 -384.19)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41915",
    "data-name": "Path 41915",
    d: "M1150.9,274.824c-1.639-2.184-14.86-4.26-14.86-4.26l-3.687-7.086-8.153,5.027a73.813,73.813,0,0,0,1.427,8.221c.815,2.31,6.294,2.427,9.641,2.393,3.079-.032,8.7.6,8.7.6l-1.9,16.781a26.279,26.279,0,0,0,4.79.714c.118-.016,6.08-19.668,4.042-22.386",
    transform: "translate(-926.442 -217.13)",
    fill: "#355389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41916",
    "data-name": "Path 41916",
    d: "M1127.667,165.768l-4.6.257s-.105.032-.138.038c-.375.069-.034,13.474.3,18.48a33.492,33.492,0,0,0,1.012,7.11,74.93,74.93,0,0,0,8.153-1.851c.795-.309,2.717-2.713,2.717-2.713a20.167,20.167,0,0,1-2.954-6.931c-.763-3.309-1.7-9.174-2.243-10.4a17.458,17.458,0,0,0-2.248-3.991",
    transform: "translate(-925.258 -136.608)",
    fill: "#9bc1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41917",
    "data-name": "Path 41917",
    d: "M1124.613,141.2l-.131,4.061s2.978,5.131,4.506,4.416c1.283-.6.144-4.5.144-4.5s-.222-.895-.53-1.923a7.427,7.427,0,0,1-.381-2.068c.032-1.388-3.608.016-3.608.016",
    transform: "translate(-926.671 -115.841)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41918",
    "data-name": "Path 41918",
    d: "M1128.772,141.18c.032-1.388-3.608.016-3.608.016l-.013.4a2.049,2.049,0,0,0,.407.462,5.012,5.012,0,0,0,3.545,1.02,6.99,6.99,0,0,1-.33-1.9",
    transform: "translate(-927.222 -115.841)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41919",
    "data-name": "Path 41919",
    d: "M1128.9,91.488a10.6,10.6,0,0,1,1.63,4.212,9.981,9.981,0,0,1-.294,3.239l-4.869-5.82Z",
    transform: "translate(-927.397 -75.395)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41920",
    "data-name": "Path 41920",
    d: "M1150.883,107.8c.069.674-.193,1.253-.585,1.293s-.765-.474-.834-1.148.194-1.253.585-1.293.765.474.833,1.148",
    transform: "translate(-947.25 -87.894)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41921",
    "data-name": "Path 41921",
    d: "M1116.218,96.971c-.112-.024-.1,5.579,1.523,6.9s4.451,1.434,5.276.106c.913-1.469.045-7.373-2.371-8.627s-4.429,1.623-4.429,1.623",
    transform: "translate(-919.827 -78.315)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41922",
    "data-name": "Path 41922",
    d: "M1100.213,80.335a9,9,0,0,0-2.679,3.814c-1.031,2.376,1.015,4.838,2.731,5.817a3.305,3.305,0,0,1,1.859,2.161l.071-.729a1.819,1.819,0,0,0-.022-.671,3.121,3.121,0,0,0-.244-.592c-.146-.312-.615-1.382-.8-1.664-.483-.745-.578-.906-.34-1.614.184-.545-.029-1.746.255-2.644l2.31-.5a4.837,4.837,0,0,0,2.176-1.189c2.1-2.418-2.048-5.114-5.318-2.19",
    transform: "translate(-904.235 -65.153)",
    fill: "#184655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41923",
    "data-name": "Path 41923",
    d: "M1113.567,122.868c.285.615.225,1.247-.132,1.413s-.878-.2-1.162-.814-.226-1.247.132-1.413.878.2,1.162.814",
    transform: "translate(-916.461 -100.551)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41924",
    "data-name": "Path 41924",
    d: "M1030.4,6.866c.262,1.079.736,2.783.736,2.783-.037.469-.176,2.419-.341,4.809l3.513-1.406a37.991,37.991,0,0,1,.115-4.133c.133-.2.355.05,1.432-1.491a3,3,0,0,0,.369-1.239s.064-.978-.155-1.069a.456.456,0,0,0-.551.224c-.079.169-.059.563-.139.732a1.215,1.215,0,0,1-.8.362c-.214-.01.027-2.894.027-2.894s.12-.817.18-1.085c.052-.228.259-.9.259-.9s.244-.97-.057-1.045c-.178-.044-.63.745-.94,1.581a17.022,17.022,0,0,1-.619,1.844c-.224-.03-.106-1.611-.106-1.611a5.057,5.057,0,0,0,.218-1.066c.211-.419.351-1.2-.02-1.26a6.455,6.455,0,0,0-.558.975s-.193.695-.305,1.019c-.2.573-.228,1.477-.331,1.876-.086.332-.164.2-.2.209a8.264,8.264,0,0,1,.075-1.076,6.375,6.375,0,0,1,.08-1.043,7.621,7.621,0,0,0,.15-1.1c.061-.818-.454-.734-.633.014-.068.285-.139.6-.21.911-.276,1.226-.268,2.406-.4,2.416a8.9,8.9,0,0,1-.058-2.137s-.263-1.19-.525-.086a9.625,9.625,0,0,0-.268,2.373,9.29,9.29,0,0,0,.064,2.51",
    transform: "translate(-849.031 -0.005)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41925",
    "data-name": "Path 41925",
    d: "M1040.546,79.42s-4.56-.212-5.737-.745c-.713-.323-6.573-5.044-6.573-5.044l.066-12.642-4.121-.313s-2.137,13.973-1.4,15.5c.764,1.58,9.341,8.082,11.056,10.9.988,1.626,3.049,23.733,3.361,23.932,2.219,1.155,9.072,2.309,8.911,1.608a254.176,254.176,0,0,1-5.567-33.2",
    transform: "translate(-842.735 -50.003)",
    fill: "#3c8f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41926",
    "data-name": "Path 41926",
    d: "M658.736,458.144c.263,1.078.736,2.783.736,2.783-.038.468-.176,2.419-.341,4.809l3.513-1.406a37.916,37.916,0,0,1,.115-4.133c.133-.2.355.05,1.432-1.491a3.009,3.009,0,0,0,.369-1.239s.064-.978-.156-1.069a.456.456,0,0,0-.551.224c-.08.169-.059.563-.139.732a1.216,1.216,0,0,1-.8.362c-.214-.011.027-2.894.027-2.894s.12-.817.18-1.085c.052-.228.259-.9.259-.9s.244-.97-.058-1.044c-.178-.044-.63.745-.94,1.581a16.872,16.872,0,0,1-.619,1.844c-.224-.03-.106-1.611-.106-1.611a5.063,5.063,0,0,0,.218-1.066c.211-.419.351-1.2-.02-1.26a6.443,6.443,0,0,0-.558.975s-.193.695-.3,1.019a19.036,19.036,0,0,0-.331,1.876c-.086.332-.164.2-.2.209a8.351,8.351,0,0,1,.075-1.076,6.375,6.375,0,0,1,.08-1.043,7.648,7.648,0,0,0,.15-1.1c.06-.818-.455-.734-.633.014-.068.285-.139.6-.21.911-.276,1.226-.269,2.407-.4,2.416a8.9,8.9,0,0,1-.058-2.137s-.263-1.19-.525-.086a9.622,9.622,0,0,0-.268,2.373,9.29,9.29,0,0,0,.064,2.51",
    transform: "translate(-542.75 -371.898)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41927",
    "data-name": "Path 41927",
    d: "M843.988,441.992c-.262,1.079-.736,2.783-.736,2.783.038.469.176,2.419.341,4.809l-3.513-1.406a37.925,37.925,0,0,0-.115-4.133c-.133-.2-.355.05-1.432-1.491a3.008,3.008,0,0,1-.369-1.24s-.064-.978.156-1.069a.456.456,0,0,1,.551.224c.08.169.059.563.139.732a1.216,1.216,0,0,0,.8.362c.214-.01-.027-2.894-.027-2.894s-.119-.817-.18-1.085c-.052-.228-.259-.9-.259-.9s-.244-.97.058-1.044c.177-.044.63.745.94,1.581a16.941,16.941,0,0,0,.619,1.844c.224-.03.106-1.611.106-1.611a5.074,5.074,0,0,1-.218-1.066c-.211-.419-.351-1.2.021-1.26a6.472,6.472,0,0,1,.559.975s.192.695.3,1.019c.2.573.228,1.477.331,1.876.086.332.164.2.2.209a8.286,8.286,0,0,0-.075-1.076,6.321,6.321,0,0,0-.08-1.043,7.636,7.636,0,0,1-.15-1.1c-.06-.818.454-.734.633.014.068.285.139.6.21.911.276,1.225.268,2.406.4,2.416a8.906,8.906,0,0,0,.059-2.137s.263-1.19.525-.086a9.628,9.628,0,0,1,.268,2.373,9.3,9.3,0,0,1-.064,2.51",
    transform: "translate(-690.713 -358.587)",
    fill: "#f8a492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41928",
    "data-name": "Path 41928",
    d: "M725.034,542.673a1.923,1.923,0,0,1,3.226.408,1.43,1.43,0,0,1,1.885.486s2-.6,2.488,2.39c0,0,1.03-.194,1.166,1.03a3.03,3.03,0,0,1-.486,2.041s.579.434.316,1.56a1.393,1.393,0,0,1-1.015,1.1s-.214,1.613-.914,2.1a2.28,2.28,0,0,1-1.652.253,1.078,1.078,0,0,1-1.069.8c-.816-.078-1.827-.855-2.741-.505a9.755,9.755,0,0,1-3.285-.019,3.311,3.311,0,0,1-1.866-3.907,1.99,1.99,0,0,1-.175-2.779s-.894-2.371.875-3.771a4.613,4.613,0,0,1,3.246-1.186",
    transform: "translate(-593.682 -446.61)",
    fill: "#07345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41929",
    "data-name": "Path 41929",
    d: "M803.412,995.065a26.869,26.869,0,0,0,2.433,2.712c.485.3-.217,3.806-1.538,4.036-.745.13-1.159-.69-1.159-.69l.214-1.011-2.783-2.867Z",
    transform: "translate(-659.747 -820.021)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41930",
    "data-name": "Path 41930",
    d: "M745.169,998.455a26.869,26.869,0,0,0,2.067,3c.443.356-.7,3.747-2.041,3.806-.756.034-1.061-.833-1.061-.833l.341-.975-2.394-3.2Z",
    transform: "translate(-611.539 -822.815)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41931",
    "data-name": "Path 41931",
    d: "M746.011,1014.925a20.494,20.494,0,0,1-1.441,1.662,17.125,17.125,0,0,1-1.5,1.208s-.953,1.729-1.213,2.333c-.58,1.343-1.231,2.84-1.137,3.592.03.241.573.5,1.024.358,1.882-.578,6.693-4.979,7.3-6.161.7-1.362-3.035-2.992-3.035-2.992",
    transform: "translate(-610.412 -836.387)",
    fill: "#07345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41932",
    "data-name": "Path 41932",
    d: "M683.977,779.572c.175-.489.342-.941.5-1.367,2,.437,4.262.917,6.587,1.413l.283,8.523c0-.658-1.748,13.594-1.748,13.594s4.519,10,7.609,15.835a10.666,10.666,0,0,1-3.7,3.172c-4.8-5.751-11.076-16.274-11.336-18.025-.15-1.007-.285-17.277,1.8-23.146",
    transform: "translate(-562.11 -641.31)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41933",
    "data-name": "Path 41933",
    d: "M743.851,788.655c-.612,6.642-1.971,19.338-1.857,20.359.341,1.273,6.389,13.022,7.478,14.733a7.338,7.338,0,0,1-3.641,3.1c-.284.077-10.265-14.126-10.809-15.253-.615-1.274-1.64-8.226-1.658-16.832l-.283-8.523c3.874.826,7.436,1.636,10.771,2.419",
    transform: "translate(-604.122 -647.928)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41934",
    "data-name": "Path 41934",
    d: "M691.478,627.891l4.561.626s3.656.089,4.108.089,3.317,16.636,4.146,22.9.187,7.369.187,7.369a40.128,40.128,0,0,1-10.06.922,32.806,32.806,0,0,1-9.453-2.8s3.8-12.032,4.556-15.788,1.956-13.32,1.956-13.32",
    transform: "translate(-564.472 -517.438)",
    fill: "#96d9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41935",
    "data-name": "Path 41935",
    d: "M658.7,510.254s-.293,12.4.175,13.353c.68,1.38,8.338,11.166,8.338,11.166s-3.658,15.309-5.2,20.6c-.155.532-.841,3.971-.841,4.307,0,.744,3.236,1.687,3.62,1.631.344-.05,3.168-14.612,4.97-21.738a20.383,20.383,0,0,1,3.092-6.733l1.253-1.781-9.621-9.643s-1.185-10.734-1.185-11.623c0-.233-4.14-.408-4.606.467",
    transform: "translate(-542.75 -419.954)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41936",
    "data-name": "Path 41936",
    d: "M754.009,514.739l12-12.224s1.672-11.559,1.79-11.995,3.1-.659,4.3-.776c.385-.038-.2,12.312-.776,14.382-.678,2.445-9.747,13.588-9.747,13.588s-1.625,6.035-1.234,10.462c.651,7.353,2.4,17.466,2.089,17.784-1.95,1.228-9.433,1.36-9.906.6-5.23-8.423,1.49-31.817,1.49-31.817",
    transform: "translate(-618.499 -403.593)",
    fill: "#13375b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41937",
    "data-name": "Path 41937",
    d: "M745.633,601.131l-.324,2.4s-.725,3.46.208,4.127,3.967-4.225,3.967-4.225l-.32-6.085Z",
    transform: "translate(-613.979 -492.268)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41938",
    "data-name": "Path 41938",
    d: "M750.755,599.321a6.9,6.9,0,0,1-3.909,3.846l.274-2.036,3.531-3.782Z",
    transform: "translate(-615.466 -492.268)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41939",
    "data-name": "Path 41939",
    d: "M785.669,565.978c0,.927-.527,1.678-1.177,1.678s-1.177-.751-1.177-1.678.527-1.678,1.177-1.678,1.177.751,1.177,1.678",
    transform: "translate(-645.52 -465.033)",
    fill: "#07345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41940",
    "data-name": "Path 41940",
    d: "M763.205,548.817c0,.533-.641.964-1.432.964s-1.432-.432-1.432-.964.641-.964,1.432-.964,1.432.432,1.432.964",
    transform: "translate(-626.587 -451.48)",
    fill: "#07345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41941",
    "data-name": "Path 41941",
    d: "M735.322,560.195a3.209,3.209,0,0,0-4.2,2.557,24.277,24.277,0,0,0-.26,3.081c-.051,2.8,1.4,5.535,2.675,5.535a6.009,6.009,0,0,0,4.921-5.8c.079-2.458-1.149-4.691-3.135-5.375",
    transform: "translate(-602.293 -461.507)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41942",
    "data-name": "Path 41942",
    d: "M768.711,588.106a.935.935,0,1,0,.916-1.12,1.034,1.034,0,0,0-.916,1.12",
    transform: "translate(-633.485 -483.728)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41943",
    "data-name": "Path 41943",
    d: "M718.357,549.061c-1.316,1.042-1.777,2.626-1.03,3.537s2.419.805,3.734-.237,1.777-2.626,1.03-3.537-2.419-.805-3.734.237",
    transform: "translate(-590.846 -451.769)",
    fill: "#07345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41944",
    "data-name": "Path 41944",
    d: "M744.409,554.09c0,.453.547.82,1.221.82s1.222-.367,1.222-.82-.547-.82-1.222-.82-1.221.367-1.221.82",
    transform: "translate(-613.458 -455.944)",
    fill: "#07345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41945",
    "data-name": "Path 41945",
    d: "M723.748,572.805a1.043,1.043,0,1,0,1.043-1.054,1.049,1.049,0,0,0-1.043,1.054",
    transform: "translate(-596.432 -471.173)",
    fill: "#07345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41946",
    "data-name": "Path 41946",
    d: "M810.369,1009.968a20.5,20.5,0,0,1-1.217,1.833,17.152,17.152,0,0,1-1.331,1.39s-.724,1.837-.905,2.469a10.663,10.663,0,0,0-.67,3.838c.061.236.579.686,1.007.407,1.65-1.074,6.058-6.106,6.509-7.356.521-1.441-3.393-2.58-3.393-2.58",
    transform: "translate(-664.38 -832.303)",
    fill: "#07345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41947",
    "data-name": "Path 41947",
    d: "M1246.135,718.648a18.365,18.365,0,0,0-9.147,4.687c-3.886,3.875-6.207,10.1-6.207,10.1l7.957,2.321s-3.18-7.421,7.4-17.107",
    transform: "translate(-1014.271 -592.229)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41948",
    "data-name": "Path 41948",
    d: "M1303.293,672.069l-.57-4.483-4.016-2.071a.621.621,0,0,1,.02-1.113l4.087-1.927.729-4.459a.621.621,0,0,1,1.065-.325l3.1,3.291,4.466-.684a.621.621,0,0,1,.639.912l-2.173,3.961,2.031,4.036a.621.621,0,0,1-.67.889l-4.44-.843-3.211,3.179a.621.621,0,0,1-1.053-.363",
    transform: "translate(-1069.97 -541.833)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41949",
    "data-name": "Path 41949",
    d: "M531.106,854.294a18.367,18.367,0,0,1,9.147,4.687c3.886,3.875,6.207,10.1,6.207,10.1L538.5,871.4s3.18-7.421-7.4-17.107",
    transform: "translate(-437.678 -704.014)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41950",
    "data-name": "Path 41950",
    d: "M477.878,807.715l.57-4.483,4.016-2.071a.621.621,0,0,0-.02-1.113l-4.087-1.927-.729-4.459a.621.621,0,0,0-1.065-.325l-3.1,3.291L469,795.943a.621.621,0,0,0-.639.913l2.173,3.962-2.031,4.036a.621.621,0,0,0,.67.889l4.439-.843,3.211,3.179a.621.621,0,0,0,1.053-.363",
    transform: "translate(-385.907 -653.617)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41951",
    "data-name": "Path 41951",
    d: "M1520.179,713.092l1.23-2.079-1.015-2.192a.332.332,0,0,1,.374-.463l2.357.528,1.771-1.643a.332.332,0,0,1,.556.213l.226,2.4,2.11,1.177a.332.332,0,0,1-.03.595l-2.217.958-.468,2.37a.332.332,0,0,1-.575.155l-1.6-1.813-2.4.288a.332.332,0,0,1-.325-.5",
    transform: "translate(-1252.721 -582.758)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41952",
    "data-name": "Path 41952",
    d: "M845.063,171.252l1.553-2.623-1.281-2.766a.419.419,0,0,1,.472-.585l2.974.666,2.235-2.073a.419.419,0,0,1,.7.268l.286,3.035,2.662,1.485a.419.419,0,0,1-.038.75l-2.8,1.209-.59,2.99a.419.419,0,0,1-.725.2l-2.015-2.287-3.026.363a.419.419,0,0,1-.411-.629",
    transform: "translate(-696.357 -134.954)",
    fill: "#f79c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41953",
    "data-name": "Path 41953",
    d: "M1462.328,243.379l-4.1,2.736,2.293,3.981-3.92,2.874,1.722,4.074-2.581,2.63,1.331,1.307,3.453-3.518-1.632-3.861,4.078-2.989-2.255-3.915,3.715-2.479Z",
    transform: "translate(-1199.658 -200.566)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41954",
    "data-name": "Path 41954",
    d: "M1445.595,590.526l-2.9-3.985-3.884,2.452-3.03-3.8-4,1.886-2.733-2.473-1.252,1.383,3.655,3.307,3.792-1.787,3.152,3.953,3.82-2.412,2.628,3.612Z",
    transform: "translate(-1176.627 -481.767)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41955",
    "data-name": "Path 41955",
    d: "M715.7,73.08l.984-4.83-4.431-1.212.76-4.8-4.092-1.68-.019-3.686-1.866.01.025,4.929,3.877,1.593-.79,4.994,4.358,1.192-.892,4.377Z",
    transform: "translate(-582.657 -46.868)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41956",
    "data-name": "Path 41956",
    d: "M519.687,185.525l1.876,3.5,4.047-.227,1.825,4.077,4.236-1.571,2.268,4.519,4.079-.965,2.892,3.991-1.511,1.095-2.163-2.984-4.3,1.019-2.18-4.344-4.307,1.6-2.014-4.5-3.952.221-1.739-3.248-2.565.688-.484-1.8Z",
    transform: "translate(-424.975 -152.889)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41957",
    "data-name": "Path 41957",
    d: "M385.248,305.432l-2.987.3-1.019-4.752-4.422-.1-1.344-3.432-1.737.68,1.8,4.59,4.191.09,1.06,4.944,4.495-.456Z",
    transform: "translate(-307.994 -245.13)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41958",
    "data-name": "Path 41958",
    d: "M353.32,635.7l-1.118,2.786-4.682-1.3-2.137,3.873-3.664-.4-.2,1.854,4.9.539,2.025-3.67,4.871,1.356,1.682-4.193Z",
    transform: "translate(-281.438 -523.87)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41959",
    "data-name": "Path 41959",
    d: "M387.811,447.676a8.316,8.316,0,1,1-11.758.245,8.316,8.316,0,0,1,11.758-.245",
    transform: "translate(-307.994 -367.018)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41960",
    "data-name": "Path 41960",
    d: "M398.912,465.929l-3.538,1.088-1.11,3.531a.361.361,0,0,1-.639.1l-2.128-3.029-3.7.036a.361.361,0,0,1-.292-.577l2.223-2.96-1.178-3.51a.361.361,0,0,1,.459-.456l3.5,1.2,2.974-2.2a.361.361,0,0,1,.576.3l-.059,3.7,3.016,2.147a.361.361,0,0,1-.1.639",
    transform: "translate(-319.276 -378.318)",
    fill: "#fed333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41961",
    "data-name": "Path 41961",
    d: "M1622.759,526.354A8.316,8.316,0,1,1,1611,526.6a8.315,8.315,0,0,1,11.758-.245",
    transform: "translate(-1325.698 -431.855)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41962",
    "data-name": "Path 41962",
    d: "M1633.859,544.606l-3.539,1.088-1.11,3.532a.361.361,0,0,1-.639.1l-2.128-3.029-3.7.036a.361.361,0,0,1-.292-.577l2.223-2.96-1.177-3.51a.361.361,0,0,1,.459-.456l3.5,1.2,2.974-2.2a.361.361,0,0,1,.576.3l-.059,3.7,3.016,2.147a.361.361,0,0,1-.1.639",
    transform: "translate(-1336.98 -443.155)",
    fill: "#fed333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41963",
    "data-name": "Path 41963",
    d: "M1460.542,447.237l1.454,2.415a.368.368,0,0,0,.658-.055l1.032-2.623,2.746-.636a.368.368,0,0,0,.151-.643l-2.175-1.792.243-2.808a.368.368,0,0,0-.565-.342l-2.377,1.515-2.6-1.1a.368.368,0,0,0-.5.432l.707,2.729-1.848,2.129a.368.368,0,0,0,.256.609Z",
    transform: "translate(-1201.01 -363.171)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41964",
    "data-name": "Path 41964",
    d: "M1430.555,784.451a1.685,1.685,0,1,1-1.685-1.685,1.685,1.685,0,0,1,1.685,1.685",
    transform: "translate(-1176.126 -645.068)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41965",
    "data-name": "Path 41965",
    d: "M308.4,494.147a1.831,1.831,0,1,1-1.825-1.685,1.759,1.759,0,0,1,1.825,1.685",
    transform: "translate(-251.145 -405.832)",
    fill: "#50bfa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41966",
    "data-name": "Path 41966",
    d: "M860.16,23.549l2.212.437s3.233-1.51,3.479-2.238.133-2.405.607-2.51a1.463,1.463,0,0,1,1.782,1.048c.263.808-.652,3.35-.431,3.581a11.708,11.708,0,0,0,2.329.627,1.668,1.668,0,0,1,1.262,1.2v0a.919.919,0,0,1-.448,1.05l-.582.312.274.607a.918.918,0,0,1-.436,1.2l-.453.217.2.366a.918.918,0,0,1-.439,1.278l-.4.171.031.108a.917.917,0,0,1-.536,1.1l-.4.159-5.89-1.164a4.067,4.067,0,0,1-1.538-.655l-2-.758a.47.47,0,0,1-.289-.54l1.119-5.233a.469.469,0,0,1,.546-.367",
    transform: "translate(-707.466 -15.823)",
    fill: "#96d9c9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinner);
export default __webpack_public_path__ + "static/media/Winner.89f6d98b0007ebc34073aac64bf0b0e0.svg";
export { ForwardRef as ReactComponent };